import React,{Component} from 'react';
import './Press.css';
class Press extends Component{
    render(){
        return(
            <>
            <h1
          style={{ textAlign: "center", marginTop: "100px", fontSize: "100px" }}
        >
          Press
        </h1>
        <h2 style={{ textAlign: "center", marginTop: "100px", fontSize: "20px" }}>For press inquiries, please contact pr@GIMSnow.com.</h2>
          <div className='review-1'>
            <div className='first'>
              <span>Bloomberg</span>
              <span>December 21, 2022</span>
              <div>
              <h3>Grocery Startup Founded by Teens Doubles Value to $570 Million</h3>
              <p>GIMS, an instant grocery delivery startup founded by two teenagers, has raised $100 million in a funding round led by Y Combinator, taking its valuation to $570 million within five months of starting services in India’s red-hot quick commerce segment.</p>
              </div>
            </div>
            <div className='second'>
            <span>Bloomberg</span>
              <span>December 21, 2022</span>
              <div>
              <h3>Grocery Startup Founded by Teens Doubles Value to $570 Million</h3>
              <p>GIMS, an instant grocery delivery startup founded by two teenagers, has raised $100 million in a funding round led by Y Combinator, taking its valuation to $570 million within five months of starting services in India’s red-hot quick commerce segment.</p>
              </div>
            </div>
            <div className='third'>
            <span>Bloomberg</span>
              <span>December 21, 2022</span>
              <div>
              <h3>Grocery Startup Founded by Teens Doubles Value to $570 Million</h3>
              <p>GIMS, an instant grocery delivery startup founded by two teenagers, has raised $100 million in a funding round led by Y Combinator, taking its valuation to $570 million within five months of starting services in India’s red-hot quick commerce segment.</p>
              </div>
            </div>
          </div>

          <div className='review-2'>
            <div className='first'>
              <span>Bloomberg</span>
              <span>December 21, 2022</span>
              <div>
              <h3>Grocery Startup Founded by Teens Doubles Value to $570 Million</h3>
              <p>GIMS, an instant grocery delivery startup founded by two teenagers, has raised $100 million in a funding round led by Y Combinator, taking its valuation to $570 million within five months of starting services in India’s red-hot quick commerce segment.</p>
              </div>
            </div>
            <div className='second'>
            <span>Bloomberg</span>
              <span>December 21, 2022</span>
              <div>
              <h3>Grocery Startup Founded by Teens Doubles Value to $570 Million</h3>
              <p>GIMS, an instant grocery delivery startup founded by two teenagers, has raised $100 million in a funding round led by Y Combinator, taking its valuation to $570 million within five months of starting services in India’s red-hot quick commerce segment.</p>
              </div>
            </div>
            <div className='third'>
            <span>Bloomberg</span>
              <span>December 21, 2022</span>
              <div>
              <h3>Grocery Startup Founded by Teens Doubles Value to $570 Million</h3>
              <p>GIMS, an instant grocery delivery startup founded by two teenagers, has raised $100 million in a funding round led by Y Combinator, taking its valuation to $570 million within five months of starting services in India’s red-hot quick commerce segment.</p>
              </div>
            </div>
          </div>

            </>
        );
    }
}
export default Press;